// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"2371bd84","453":"fe5def42","806":"5ccd09ed"}[chunkId] + ".chunk.js";
};